<template src="./BaseDialog.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        modelValue: { type: Boolean, required: true },
        label: { type: String, required: true },
        width: { type: Number, default: 500 }
    },
    emits: ["update:modelValue"],
    computed: {
        valueSync: {
            get() {
                return this.modelValue;
            },
            set(value: boolean) {
                this.$emit("update:modelValue", value);
            }
        }
    },
    methods: {
        close() {
            this.$emit("update:modelValue", false);
        }
    }
});
</script>

<style></style>
